/**
 * Type-specific TypeSpecificSection component for ahoy_company.
 *
 * Renders the People list with the company-flavoured section title.
 * Thin wrapper around the shared `<PeopleSection>` — exists so the registry
 * can register a `{ object }`-only component rather than embedding the
 * sectionTitle config at the dispatch site.
 */

import type { CrmObject } from '@/types/crm';

import { PeopleSection } from './people-section';

export function CompanyPeopleSection({ object }: { object: CrmObject }) {
  return <PeopleSection object={object} sectionTitle='People' />;
}
